import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '../default';

import {
  getAnnualCampaignMaps,
  createNewAnnualCampaignMap,
  updateAnnualCampaignMap,
  updateAnnualCampaignMapTeam,
  updateAnnualCampaignMapOwner,
  updateOverallBehaviour,
  updateAcmLink,
  getAnnualCampaignMap,
  createNewSegment,
  editSegment,
  deleteSegment,
  createNewKeyDate,
  editKeyDate,
  deleteKeyDate,
  addNewCampaign,
  addExistingCampaign,
  deleteCampaignFromACM,
  cloneAnnualCampaignMap,
} from './actions';
import { AnnualCampaignMapsState } from './types';

export default createReducer(initialState as AnnualCampaignMapsState, builder => {
  builder
    .addCase(getAnnualCampaignMaps.pending, state => {
      state.pending = true;
    })
    .addCase(getAnnualCampaignMaps.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload;
      state.lastRefreshDate = new Date().toISOString();
    })
    .addCase(getAnnualCampaignMaps.rejected, state => {
      state.pending = false;
      state.error = true;
    })
    .addCase(createNewAnnualCampaignMap.pending, state => {
      state.pending = true;
    })
    .addCase(createNewAnnualCampaignMap.fulfilled, state => {
      state.pending = false;
    })
    .addCase(createNewAnnualCampaignMap.rejected, state => {
      state.pending = false;
    })
    .addCase(updateAnnualCampaignMap.pending, state => {
      state.pending = true;
    })
    .addCase(updateAnnualCampaignMap.fulfilled, state => {
      state.pending = false;
    })
    .addCase(updateAnnualCampaignMap.rejected, state => {
      state.pending = false;
    })
    .addCase(updateAnnualCampaignMapTeam.pending, state => {})
    .addCase(updateAnnualCampaignMapTeam.rejected, state => {})
    .addCase(updateAnnualCampaignMapTeam.fulfilled, (state, { payload }) => {
      state.map = payload;
    })
    .addCase(updateAnnualCampaignMapOwner.pending, state => {})
    .addCase(updateAnnualCampaignMapOwner.rejected, state => {})
    .addCase(updateAnnualCampaignMapOwner.fulfilled, (state, { payload }) => {
      state.map = payload;
    })
    .addCase(updateOverallBehaviour.pending, state => {})
    .addCase(updateOverallBehaviour.rejected, state => {})
    .addCase(updateOverallBehaviour.fulfilled, (state, { payload }) => {
      state.map = payload;
    })
    .addCase(updateAcmLink.pending, state => {})
    .addCase(updateAcmLink.rejected, state => {})
    .addCase(updateAcmLink.fulfilled, (state, { payload }) => {
      state.map = payload;
    })
    .addCase(cloneAnnualCampaignMap.pending, state => {
      state.pending = true;
    })
    .addCase(cloneAnnualCampaignMap.fulfilled, state => {
      state.pending = false;
    })
    .addCase(cloneAnnualCampaignMap.rejected, state => {
      state.pending = false;
    })
    .addCase(getAnnualCampaignMap.pending, state => {
      state.pending = true;
      state.map = undefined;
    })
    .addCase(getAnnualCampaignMap.rejected, state => {
      state.pending = false;
    })
    .addCase(getAnnualCampaignMap.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.map = payload;
    })
    .addCase(createNewSegment.pending, state => {})
    .addCase(createNewSegment.rejected, state => {})
    .addCase(createNewSegment.fulfilled, (state, { payload }) => {
      state.map?.segments.push(payload);
    })
    .addCase(editSegment.pending, state => {})
    .addCase(editSegment.rejected, state => {})
    .addCase(editSegment.fulfilled, (state, { payload }) => {
      if (state.map)
        state.map.segments = state.map.segments.map(s => (s.id === payload.id ? payload : s));
    })
    .addCase(deleteSegment.pending, state => {})
    .addCase(deleteSegment.rejected, state => {})
    .addCase(deleteSegment.fulfilled, (state, { payload }) => {
      if (state.map) {
        state.map.segments = state.map.segments.filter(s => s.id !== payload.id);
      }
    })
    .addCase(createNewKeyDate.pending, state => {})
    .addCase(createNewKeyDate.rejected, state => {})
    .addCase(createNewKeyDate.fulfilled, (state, { payload }) => {
      state.map?.keyDates.push(payload);
    })
    .addCase(editKeyDate.pending, state => {})
    .addCase(editKeyDate.rejected, state => {})
    .addCase(editKeyDate.fulfilled, (state, { payload }) => {
      if (state.map)
        state.map.keyDates = state.map.keyDates.map(s => (s.id === payload.id ? payload : s));
    })
    .addCase(deleteKeyDate.pending, state => {})
    .addCase(deleteKeyDate.rejected, state => {})
    .addCase(deleteKeyDate.fulfilled, (state, { payload }) => {
      if (state.map) {
        state.map.keyDates = state.map.keyDates.filter(s => s.id !== payload.id);
      }
    })
    .addCase(addNewCampaign.pending, state => {
      state.lastError = undefined;
    })
    .addCase(addNewCampaign.rejected, (state, { payload }) => {
      state.lastError = payload as string;
    })
    .addCase(addNewCampaign.fulfilled, (state, { payload }) => {
      state.lastError = undefined;
      if (state.map) {
        state.map.campaigns = payload.campaigns;
      }
    })
    .addCase(addExistingCampaign.pending, state => {})
    .addCase(addExistingCampaign.rejected, state => {})
    .addCase(addExistingCampaign.fulfilled, (state, { payload }) => {
      if (state.map) {
        state.map.campaigns = payload.campaigns;
      }
    })
    .addCase(deleteCampaignFromACM.pending, state => {})
    .addCase(deleteCampaignFromACM.rejected, state => {})
    .addCase(deleteCampaignFromACM.fulfilled, (state, { payload }) => {
      if (state.map) {
        state.map.campaigns = state.map.campaigns.filter(
          ({ campaign }) => campaign.campaignDisplayId !== payload.campaignDisplayId,
        );
      }
    });
});
